export default ({ value }) => {
    if (!value) {
        return '';
    }

    return value.replace(/^(\..)/, (part) => part.substring(1).toUpperCase());
};
